import { FromOptions } from './from-options.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.js';
import { ChevronDown } from 'lucide-react';
import { ManualPaymentEntry } from './manual-payment-entry.js';
import { Button } from '@/components/ui/button.js';
import { CsvPaymentEntry } from './csv-payment-entry.js';

interface CreatePaymentProps {
  from: FromOptions;
  editId?: string;
  coach?: {
    id: string;
    fullNameOrEmail: string;
  };
  'data-testid'?: string;
}

export const CreatePayment = ({ from, editId, coach, 'data-testid': dataTestId }: CreatePaymentProps) => {
  return (
    <>
      {/*
        Update payment navigates here with ?editId=. ManualPaymentEntry inside the closed
        dropdown is unmounted, so the edit modal needs a host outside the menu. Keep this
        trigger hidden — a visible second "Add a payment" button is a duplicate of the dropdown.
      */}
      {editId ? (
        <ManualPaymentEntry from={from} coach={coach} editId={editId} trigger={<span className="hidden" />} />
      ) : null}
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button className="ml-auto hidden h-8 lg:flex" data-testid={dataTestId}>
            Add payment
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <ManualPaymentEntry
            from={from}
            coach={coach}
            trigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()} data-testid="teacher-payments-menu-item-add">
                Add a payment
              </DropdownMenuItem>
            }
          />
          <CsvPaymentEntry from={from} />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
